import "../loader/loader.css"
import React from 'react'
function Loader(){
    return(
        <div className="loadercontainer">
            <span class="tile-1"></span>
            <span class="tile-2"></span>
            <span class="tile-3"></span>
            <span class="tile-4"></span>
        </div>
    )
}
export default Loader